import Swal from "sweetalert2";
import Vue from 'vue'
import {utils} from "./utils";
import {responses} from "./responses";
import {errorHandler} from "./errorHandler";
import queryStringify from "qs-stringify";
import TimeManager from "@/Services/TimeManager";
import axios from "axios";

window.bankApi = `https://lna.abc.co.zm/BankOnboard/`
// window.bankApi = `http://192.168.1.204:8080/BankOnboard/`

window.responses = responses;
window.errorHandler = errorHandler

const EventBus = new Vue()
window.EventBus = EventBus

window.log = (val) => console.log(val);
window.Swal = Swal;

window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}

Vue.prototype.$utils = utils;
window.$utils = utils;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;
window.showNotification = (title , message) =>{
    if ('serviceWorker' in navigator && 'PushManager' in window) {
        navigator.serviceWorker.ready
            .then((registration) => {
                registration.showNotification(title, {
                    body: message,
                    icon: '/favicon.ico',
                    vibrate : [200,100,200],
                    actions: [{ action: 'view', title: 'View Details' }],
                    // Other options like badge, image, etc.
                });
            })
            .catch((error) => {
                console.error('Error triggering push notification:', error);
            });
    }
}
const axiosInstance = axios.create();
axiosInstance.defaults.headers.common['Api-Key'] = 'f6fef6af-0fca-49fe-bec4-89ddb6d24502';
axiosInstance.interceptors.request.use(config => {
    const localID = getOrCreateLocalID(); // Get localID from localStorage
    if (config.method === 'post' || config.method === 'put') {
        config.data = config.data || {};
        config.data.localid = localID; // Append to request body
    }
    return config;
}, error => {
    if (error.code === 'ECONNABORTED') {
        setNewLocalId();
    }
    return Promise.reject(error);
});
window.axios = axiosInstance;

function setNewLocalId() {
    let localID = generateUUID(); // Generate new UUID
    localStorage.setItem('localid', localID);
    return localID;
}
function getOrCreateLocalID() {
    let localID = localStorage.getItem('localid');
    if (!localID) {
        localID = generateUUID();
    }
    return localID;
}
window.stringify = (object) => queryStringify(object);
window.openUrl = (url,target = '_blank') => window.open(url,target,"_blank","toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=yes, width=900, height=700");
window.dateTimeManager = TimeManager
Vue.prototype.$dateTimeManager = TimeManager;

window.isValidImageUrl =async (url) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
    });
}